import { render, staticRenderFns } from "./integral_vip_list.vue?vue&type=template&id=11ae76ae&scoped=true&"
import script from "./integral_vip_list.vue?vue&type=script&lang=js&"
export * from "./integral_vip_list.vue?vue&type=script&lang=js&"
import style0 from "./integral_vip_list.vue?vue&type=style&index=0&id=11ae76ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ae76ae",
  null
  
)

export default component.exports